function Form(formSelector) {
	var $modalForm = $(formSelector);
	var $modalLayer = $('.modal-layer');
	var $formInput = $('.js-modalform-textinput', $modalForm);
	var $closeButton = $('.js-modalform-close', $modalForm);

	var checkInputValue = function (element) {
		if (element.val() !== '') {
			element
				.parents('.js-modalform-item')
				.addClass('is-not-empty');
		} else {
			element
				.parents('.js-modalform-item')
				.removeClass('is-not-empty');
		}
	};

	var focusInput = function () {
		var $this = $(this);
		$this
			.parents('.js-modalform-item')
			.addClass('is-focused');
	};

	var blurInput = function () {
		var $this = $(this);
		$this
			.parents('.js-modalform-item')
			.removeClass('is-focused');
		checkInputValue($this);
	};

	var closeForm = function () {
				
		console.log($formInput);

		$formInput.each(function (i, el) {
			$(el).val('');
			checkInputValue($(el));
		})

		$modalForm.find('.js-modalform').validate().resetForm();
		
		$modalForm.velocity(
			'transition.bounceUpOut',
			{
				complete: function () {
					$modalLayer.velocity('transition.fadeOut');
				}
			},
			500
		);
		global.blurOnLeave(this);
	};

	this.openForm = function () {
		$modalLayer.velocity('transition.fadeIn');
		$modalForm.velocity('transition.bounceDownIn', {delay: 500}, 500);
	};

	//Валидация формы
	$('.js-modalform', $modalForm).each(function (key, form) {
		$(form).validate({
			errorElement: 'em',
			errorClass: 'modal-form__label-error',
			validClass: 'modal-form__label-success',
			//onfocusout  	: false,
			//*
			rules: {
				captcha: {
					required: true,
					minlength: 5,
					remote: function (el) {
						var result = {
							url: location.href,
							type: 'post',
							dataType: 'json',
							//contentType	: "application/json; charset=utf-8",
							cache: false,
							data: 'sid=' + $(el).data('captcha') + '&word=' + $(el).val() + '&ajax_call=Y&act=check-captcha',
							dataFilter: function (response) {
								response = JSON.parse(response);

								return response.success;
							}
						};

						return result;
					}
				}
			},
			messages: {
				captcha: $('input#captcha-input', form).data('msgCaptcha')
			},
			//*/
			submitHandler: function (form) {
				setTimeout(function () {
					$modalForm.velocity(
						'transition.bounceDownOut',
						{
							complete: function () {
								/** check if form is My report */
								if ($(form).attr('id') == 'MY_REPORT') {
									/** create pdf */
									var pids = [];

									$('form#my-report li#my-report-page').each(function (i, el) {
										var
											li	= $(el),
											pid	= li.data('pid')
										;

										if (li.find('input.js-myreport-item').is(':checked')) {
											pids.push(pid);
										}
									});

									if (pids.length > 0) {
										$.get(location.href + (location.href.indexOf('?') == -1 ? '?' : '&') + 'pdf=Y&pdfName=Y&generatePDF=Y&pid=' + pids, function (pdfName) {
											if (pdfName.length > 0) {
												$(form).find('input#pdfName').val(pdfName);

												/** send emails */
												$.post(location.href, $(form).serialize(), function (response) {
													// console.log(response);
												}, 'json');
											}
										});
									}
								} else {
									/** send emails */
									$.post(location.href, $(form).serialize(), function (response) {
										// console.log(response);
									}, 'json');
								}

								$modalLayer.velocity('transition.fadeOut');
							}
						},
						500
					);
				}, 100);
			},
			invalidHandler: function (form) {
				setTimeout(function () {
					// console.log($('.js-modalform-item', form));

					$('.js-modalform-item', form)
						.find('.modal-form__label-error')
						.velocity('callout.shake', 500);
				}, 100);
			}
		});
	});

	/** captcha reload */
	$('.js-captcha-reload', $modalForm).on('click', function () {
		var
			input = $('input#captcha-input', $modalForm),
			sid = $('input#captcha_sid', $modalForm),
			img = $('img#captcha', $modalForm)
		;

		$.post(location.href, 'ajax_call=Y&act=reload-captcha', function (response) {
			if (response.success) {
				input.data({captcha: response.captcha});
				sid.val(response.captcha);
				img.attr('src', '/bitrix/tools/captcha.php?captcha_sid=' + response.captcha);
			}
		}, 'json');
	});

	$formInput.on('blur', blurInput);
	$formInput.on('focus', focusInput);
	$closeButton.on('click', closeForm);

	global.blurOnLeave(this);
}

var
	shareForm = new Form('div.SHARE'),
	feedbackForm = new Form('div.FEEDBACK');

/** share form */
$('.js-send-href').on('click', function () {
	shareForm.openForm();
});

/** feedback form */
$('.js-feedback-form').on('click', function () {
	feedbackForm.openForm();
});

module.exports = Form;



/** WEBPACK FOOTER **
 ** ./frontend/components/forms/forms.custom.js
 **/